import {Component, inject, signal, ChangeDetectionStrategy} from '@angular/core';
import { environment } from '../../../../environments/environment';
import {SystemParamsService} from "../../services/system-params-service/system-params.service";

@Component({
    selector: 'app-footer',
    imports: [],
    templateUrl: './footer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './footer.component.css'
})
export class FooterComponent {
  systemParamsService = inject(SystemParamsService);

  ngOnInit() {
    this.systemParamsService.loadSystemParams();
  }

  environment = signal(environment.stage);
}
